class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("gaia-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this._headerObserver = null;

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  _getHeaderHeight() {
    return (
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height",
        ),
      ) || 0
    );
  }

  _setTop(px) {
    this.style.top = `${px}px`;
  }

  open() {
    const headerContent = document.querySelector(".header-content");
    if (headerContent) {
      const bottom = headerContent.getBoundingClientRect().bottom;
      this._setTop(bottom > 0 ? bottom : this._getHeaderHeight());

      // Track header--hidden changes while notification is open
      this._headerObserver = new MutationObserver(() => {
        if (headerContent.classList.contains("header--hidden")) {
          this._setTop(0);
        } else {
          this._setTop(this._getHeaderHeight());
        }
      });
      this._headerObserver.observe(headerContent, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
    this.notification.classList.add("animate", "active");
    this.notification.addEventListener(
      "transitionend",
      () => {
        // Prevent scroll jump when focusing notification
        if (typeof this.notification.focus === "function") {
          try {
            this.notification.focus({ preventScroll: true });
          } catch (e) {
            // fallback for browsers that don't support preventScroll
            this.notification.focus();
          }
        }
        trapFocus(this.notification);
      },
      { once: true },
    );
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    if (this._headerObserver) {
      this._headerObserver.disconnect();
      this._headerObserver = null;
    }
    this.style.top = "";
    this.notification.classList.remove(
      "active",
      "header-is-sticky",
      "header-offscreen",
    );
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
